<template>
  <div class="loading-widget-wrap">
    <v-sheet
      v-if="value"
      :class="[
        'd-flex justify-center align-center',
        small ? 'py-2' : 'py-10 py-md-13 py-lg-16',
      ]"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        :color="color"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <template v-else>
      <transition v-if="transition" :name="transition">
        <div>
          <slot name="default">
            <slot name="fallback">
              <FallbackTextCard :text="fallbackText"></FallbackTextCard>
            </slot>
          </slot>
        </div>
      </transition>
      <slot v-else name="default">
        <slot name="fallback">
          <FallbackTextCard :text="fallbackText"></FallbackTextCard>
        </slot>
      </slot>
    </template>
  </div>
</template>

<script>
import FallbackTextCard from "../cards/FallbackTextCard.vue";

export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    color: {
      type: String,
      default: "primary",
    },
    value: {
      type: Boolean,
      default: true,
    },
    transition: {
      type: String,
    },
    fallbackText: {
      type: String,
    },
  },
  components: { FallbackTextCard },
};
</script>

<style lang="scss">
.loading-widget-wrap {
  height: 100%;
  width: 100%;
}
</style>
